/* eslint-disable max-len */
import { SvgProps } from './types'

export const MoneyRotationIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M31.9633 32.2175L29.8756 30.1339L27.418 39.2986L36.595 36.8451L34.5073 34.7615"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.7657 34.7656C42.3564 27.1749 42.3564 14.8293 34.7657 7.2386C30.8902 3.36313 25.7736 1.46443 20.6816 1.54663"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.78987 9.80714L11.8776 11.8908L14.3352 2.72607L5.1582 5.18369L7.24595 7.26733"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.24604 7.26733C-0.352847 14.858 -0.352847 27.2036 7.24604 34.7943C11.1256 38.6698 16.2505 40.5644 21.3506 40.4822"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.92 18.3514C22.9172 15.6801 18.3965 15.9965 18.3636 18.7788C18.3472 20.024 19.8061 20.5953 21.0267 20.7885C25.4734 21.4912 24.2446 25.6708 21.0267 25.5105C18.5855 25.3914 17.8787 23.7392 17.8047 23.3447"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0801 14.2704V16.5143"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0801 25.5187V27.7626"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0149 30.8655C26.4532 30.8655 30.8618 26.4568 30.8618 21.0185C30.8618 15.5802 26.4532 11.1716 21.0149 11.1716C15.5766 11.1716 11.168 15.5802 11.168 21.0185C11.168 26.4568 15.5766 30.8655 21.0149 30.8655Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
